import { Fetch } from "./FetchImplementation/Fetch";

export type HttpStatusCode = number;

export interface IHttpClientResponse {
    json<T>(): Promise<T>;
    blob(): Promise<Blob>;
    text(): Promise<string>;
    status: HttpStatusCode;
    headers: Headers;
}

export interface IHttpClientResponseSync {
    json<T>(): T;
    status: HttpStatusCode;
}

export type HttpStatusHandler = (response: Response) => Promise<void>;
export type HttpStatusHandlers = Record<HttpStatusCode, HttpStatusHandler>;

export interface IHttpClientRequestWrapper extends PromiseLike<IHttpClientResponse> {
    json<T>(): Promise<T>;
    blob(): Promise<Blob>;
    text(): Promise<string>;
    withQueryParams(queryParams: QueryParamsObject | false | undefined): this;
    withJsonBody(serializableBody: unknown | undefined | {} | unknown[]): this;
    withRawBody(body: Buffer | string | false | undefined): this;
    withContentType(contentType: string): this;
    withBodyFromBuffer(body: undefined | false | Buffer): this;
    withAbortSignal(signal?: AbortSignal): this;
    withHttpStatusHandler(statusCode: HttpStatusCode, handler: HttpStatusHandler): this;
    withHttpStatusHandlers(httpStatusHandlers: HttpStatusHandlers): this;
    acceptCode(code: HttpStatusCode): this;
}

export interface IHttpClient {
    get(url: string): IHttpClientRequestWrapper;
    post(url: string): IHttpClientRequestWrapper;
    put(url: string): IHttpClientRequestWrapper;
    patch(url: string): IHttpClientRequestWrapper;
    delete(url: string): IHttpClientRequestWrapper;
    url(path: string, params?: QueryParamsObject): string;
    postSync(url: string, params: undefined | QueryParamsObject, data: {}): IHttpClientResponseSync;
    createFetchImpl(): Fetch;
}

export interface QueryParamsObject {
    [key: string]: null | undefined | number | string | boolean | Array<string | number>;
}
